export default "__VITE_ASSET__55da4e7f__"